import { render, staticRenderFns } from "./CSVImports.vue?vue&type=template&id=8f025760&"
import script from "./CSVImports.vue?vue&type=script&lang=ts&"
export * from "./CSVImports.vue?vue&type=script&lang=ts&"
import style0 from "./CSVImports.vue?vue&type=style&index=0&id=8f025760&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports